import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { bootstrapApplication } from '@angular/platform-browser';

import { App } from '@app/app';
import { appConfig } from '@app/app.config';
import { environment } from '@environments/environment';

registerLocaleData(localePt, 'pt-BR');
document.documentElement.classList.remove(
  'theme-blue-slate',
  'theme-honey-brick',
  'theme-red-garnet',
  'theme-ruby-honey',
);
document.documentElement.classList.add(environment.themeClass);

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
